import React, { useContext } from "react";
import { Switch, Link } from "react-router-dom";
import { TableHeaderNoAdd, OrangeLinkButton } from "./formComponents";
import SectionForm from "./sectionForm";
import { MyContext, ListContext } from "./MyContext";

import { Container } from "./styleCustom";
// import AuthHelperMethods from "./AuthHelperMethods";

import PrivateRoute from "./privateRoute";
import SectionTable from "./sectionTable.js";
import Auth from "./Auth";

const Sections = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);

  return (
    <>
      <Container style={{ flexWrap: "wrap", flex: "0 0 100%" }}>
        <div
          style={{
            display: "flex",
            flex: "1 1 100%",
            justifyContent: "center",
            width: 400,
          }}
        >
          <Switch>
            {" "}
            <PrivateRoute
              path={`${props.match.url}/sectionform/:id`}
              component={SectionForm}
            />
            <PrivateRoute
              path={`${props.match.url}/sectionform/:id`}
              component={SectionForm}
            />
          </Switch>
        </div>

        <div style={{ flex: "1 1 100%" }}>
          <TableHeaderNoAdd title="Sections">
            <Link to={`${props.match.url}/sectionform/add`}>
              <OrangeLinkButton>{"Add New Section"} </OrangeLinkButton>{" "}
            </Link>
          </TableHeaderNoAdd>

          <PrivateRoute
            path={`/admin/setup/sections/`}
            component={SectionTable}
          />
        </div>
      </Container>
    </>
  );
};

export default Sections;
